import { render, staticRenderFns } from "./liaoban.vue?vue&type=template&id=4aaaf7b0&scoped=true&"
import script from "./liaoban.vue?vue&type=script&lang=js&"
export * from "./liaoban.vue?vue&type=script&lang=js&"
import style0 from "./liaoban.vue?vue&type=style&index=0&id=4aaaf7b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaaf7b0",
  null
  
)

export default component.exports